import { useCallback } from 'react';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const getFilesByDocumentId = (documentId?: string) =>
  api.get(API_URL.DOCUMENTS_FILES_BY_DOCUMENT_ID(documentId || ''));

const useOpenFile = () => {
  const handleOpen = useCallback(async (fileId: string, customFieldUrl?: string) => {
    if (customFieldUrl) {
      window.open(customFieldUrl, '_blank');
      return;
    }
    const response = await getFilesByDocumentId(fileId);
    const fileUrl = response?.data?.files?.[0]?.s3_url;

    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }, []);

  return { handleOpen };
};

export default useOpenFile;
